import {
  parseItemListParams,
  useAnalyticsStorageParams,
} from '@redbubble/next-analytics/gtm';
import { useEffect } from 'react';
import { trackGA4SelectItemEvent, trackGA4ViewItemEvent } from '../analytics';
import { triggerPersonalizationEvent } from '../lib/personalizationEventsTriggers';
import { useCurrentInventoryStore } from './useCurrentInventoryItem';

export const useAnalytics = () => {
  const currentInventoryItem = useCurrentInventoryStore(
    (state) => state.currentInventoryItem
  );

  const { analyticsStorageParams, resetAnalyticsParams } =
    useAnalyticsStorageParams(currentInventoryItem);

  // biome-ignore lint/correctness/useExhaustiveDependencies: useExhaustiveDependencies
  useEffect(() => {
    const itemListParams = parseItemListParams(analyticsStorageParams);

    if (itemListParams.itemListID) {
      trackGA4SelectItemEvent({
        item: currentInventoryItem,
        itemListParams,
      });
    }

    trackGA4ViewItemEvent({
      item: currentInventoryItem,
      itemListParams,
    });

    triggerPersonalizationEvent({
      workId: `${currentInventoryItem.workId}`,
      inventoryItemId: currentInventoryItem.id,
      eventName: 'user-viewed-product',
    });

    resetAnalyticsParams();
  }, [currentInventoryItem]);
};
